import { render, staticRenderFns } from "./candidacy-election-component.vue?vue&type=template&id=44764fe6&scoped=true"
import script from "./candidacy-election-component.ts?vue&type=script&lang=ts&external"
export * from "./candidacy-election-component.ts?vue&type=script&lang=ts&external"
import style0 from "./candidacy-election-component.scss?vue&type=style&index=0&id=44764fe6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44764fe6",
  null
  
)

export default component.exports